import routes from './routes'
import { Fetch } from '../fetch'
import { setDriverPayload } from '../../tools/dataParse'
class MyDrivers {
  getMyDrivers ({ offset, body }) {
    return Fetch('get', routes.getMyDrivers({ offset }, body))
  }

  setDriver (payload) {
    let route = routes.addMyDriver
    let method = 'post'

    if (payload.driver_id) {
      route = routes.updateMyDriver
      method = 'put'
    }

    return Fetch(method, route, setDriverPayload(payload))
  }

  destroy (driver_id) {
    return Fetch('delete', routes.deleteMyDriver(driver_id), null)
  }
}

export default new MyDrivers()
